import React from 'react';
import { BuildingPermitRevisionGroup } from '@th/shared/src/types/BuildingPermitRevisionGroup';

type Props = {
  permitRevisionGroup: BuildingPermitRevisionGroup;
  containerClassName?: string;
  rowClassName?: string;
  showAddress?: boolean;
};

export default function PermitRevisionGroupInfo({
  permitRevisionGroup,
  containerClassName = '',
  rowClassName = '',
  showAddress = true,
}: Props) {
  return (
    <div className={containerClassName}>
      <div className={rowClassName}>
        <span className="font-bold">Permit Id</span>:{' '}
        {permitRevisionGroup.original.permitNum}
      </div>
      {showAddress && (
        <div className={rowClassName}>
          <span className="font-bold">Address</span>:{' '}
          {permitRevisionGroup.original.address.formattedAddressShortOneLiner()}
        </div>
      )}
      <div className={rowClassName}>
        <span className="font-bold">Type</span>:{' '}
        {permitRevisionGroup.original.permitType}
      </div>
      <div className={rowClassName}>
        <span className="font-bold">Structure</span>:{' '}
        {permitRevisionGroup.original.structureType}
      </div>
      <div className={rowClassName}>
        <span className="font-bold">Status</span>:{' '}
        {permitRevisionGroup.original.stage}
      </div>
      <div className={rowClassName}>
        <span className="font-bold">Application Date</span>:{' '}
        {permitRevisionGroup.original.applicationDate}
      </div>
      {!permitRevisionGroup.original.completedDate &&
        permitRevisionGroup.original.issuedDate && (
          <div className={rowClassName}>
            <span className="font-bold">Issued Date</span>:{' '}
            {permitRevisionGroup.original.issuedDate}
          </div>
        )}
      {permitRevisionGroup.original.completedDate && (
        <div className={rowClassName}>
          <span className="font-bold">Completed Date</span>:{' '}
          {permitRevisionGroup.original.completedDate}
        </div>
      )}
      <div className={rowClassName}>
        <span className="font-bold">Description</span>:{' '}
        {permitRevisionGroup.original.description}
      </div>
    </div>
  );
}
